import { AbstractDestroyable, assert, Burden, Callback, Destroyable } from '@deqo/foundation';


export class Burdens extends AbstractDestroyable {

    constructor(...burdens: Burden[]) {
        super();
        this.add(...burdens);
    }

    public add(...burdens: Burden[]): this {
        this.burden(...burdens);
        return this;
    }

    public attach(burden: Burden): this {
        this.burden(burden);
        return this;
    }
}

export class KeyedBurdens implements Destroyable {

    private isDestroyed = false;
    private store = {} as Record<string, Burden>;

    public destroy(): void {
        this.isDestroyed = true;
        Burden.resolveAll(Object.values(this.store));
        this.store = null;
    }

    public destroyed(): boolean {
        return this.isDestroyed;
    }

    public keys(): readonly string[] {
        return Object.keys(this.store);
    }

    public get(key: string): Burden | undefined {
        this.guardDestroyed();
        return this.store[key];
    }

    public has(key: string): boolean {
        this.guardDestroyed();
        return !!this.store[key];
    }

    public addMaybe(key: string, provider: Callback<Burden>): boolean {
        if (this.has(key)) return false;
        this.set(key, provider());
        return true;
    }

    public set(key: string, burden: Burden): this {
        this.guardDestroyed();
        this.delete(key);
        this.store[key] = burden;
        return this;
    }

    public delete(key: string): boolean {
        this.guardDestroyed();
        const r = !!this.store[key];
        delete this.store[key];
        return r;
    }

    public resolve(key: string): void {
        this.guardDestroyed();
        const burden = this.get(key);
        assert(!!burden, `KeyedBurdens.resolve: ${key} is not present.`);
        this.delete(key);
        Burden.resolve(burden);
    }

    public resolveMaybe(key: string): boolean {
        this.guardDestroyed();
        const burden = this.get(key);
        if (burden) {
            this.delete(key);
            Burden.resolve(burden);
            return true;
        }
        return false;
    }

    private guardDestroyed() {
        assert(!this.isDestroyed, 'KeyedBurdens is destroyed.');
    }
}
